import { ReactNode } from 'react';
import { TipPlacement } from 'ui/tooltip';

export enum SEGMENTED_CONTROL_SIZES {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum SEGMENTED_CONTROL_VARIANTS {
  SOLID = 'solid',
  TRANSLUCENT = 'translucent',
}

export type SegmentedControlOption = {
  Icon?: React.FunctionComponent<React.PropsWithChildren<{ color: string }>>;
  disabled?: boolean;
  key?: string;
  /** Display name */
  name?: string | ReactNode;
  tooltip?: { content: string; placement?: TipPlacement };
  /** Unique value */
  value: string;
  variant?: SEGMENTED_CONTROL_VARIANTS;
};

export type SegmentedControlProps = {
  isDisabled?: boolean;
  /** This prop makes both the wrapper full width and the options fill the available space in the wrapper */
  isFullWidth?: boolean;
  /** Callback function to trigger on selection */
  onSelect?: (value: any) => void;
  optionMinWidth?: string;
  options: SegmentedControlOption[];
  size?: SEGMENTED_CONTROL_SIZES;
  /** Currently selected value, if controlled by parent */
  value?: string;
  variant?: SEGMENTED_CONTROL_VARIANTS;
};

export type SegmentedControlNoSizeProps = Omit<SegmentedControlProps, 'size'>;
